import { AiOutlineDownload } from "react-icons/ai";
import { BsBriefcaseFill } from "react-icons/bs";

const AboutMe = () => {
  return (
    <main className="about-page">
      <div className="ml-72">
        <section className="section about" id="about">


          <div className="experience pt-48">
            <h1 className="title">Experience</h1>
            <div className="timeLine">
              <div className="timeLine-item">
                <div className="timeLine-icon">
                  <BsBriefcaseFill />
                </div>
                <div className="tl-details">
                  <div className="tl-details-top">
                    <p className="tl-duration">Jan-2025-Jun-2025</p>
                    <p>
                      <span className="ui">Intern UI/UX Designer </span>
                      <span>CollegePur-India</span>
                    </p>
                  </div>

                  <p>
                    As a UI Designer, I’m part of a collaborative team working on a student platform that brings together key college information in one centralized place. Together, we’ve followed the entire Design Thinking process — including empathizing with users, defining key problems, ideating potential solutions, prototyping in Figma, and conducting usability testing — to ensure our designs are both effective and user-centered.

                    I actively contribute to creating responsive, high-quality UI designs in Figma, focusing on clarity, accessibility, and consistency. With my frontend background, I also support design decisions by considering feasibility and responsive behavior early in the process. Our shared goal is to deliver a platform that’s intuitive, visually appealing, and solves real student needs.
                  </p>
                  <br />

                </div>
              </div>
            </div>
            {/* <div className="timeLine">
              <div className="timeLine-item">
                <div className="timeLine-icon">
                  <BsBriefcaseFill />
                </div>
                <div className="tl-details">
                  <div className="tl-details-top">
                    <p className="tl-duration">April 2024-June 2024</p>
                    <p>
                      <span className="ui">UI Designer/Developer</span>
                      <span>Freelancing</span>
                    </p>
                  </div>

                  <p>
                    I’ve been enhancing my skills in JavaScript and React through daily challenges on Codewars and HackerRank, while also improving my UI/UX design expertise with Figma through dummy projects and various case studies. I’ve worked on building scalable, responsive web applications utilizing React and Context API for efficient state management.
                  </p>
                  <br />
                  <p>
                    Recently, for a client I developed a personal blog website and led the creation of a responsive event platform with React and Tailwind CSS, improving load times by 40% and user engagement by 25%. As a freelancer, I specialize in frontend development, focusing on React, UI/UX design, and Tailwind CSS.

                  </p>

                </div>
              </div>
            </div> */}
            <hr />
            <div className="timeLine">
              <div className="timeLine-item">
                <div className="timeLine-icon">
                  <BsBriefcaseFill />
                </div>
                <div className="tl-details">
                  <div className="tl-details-top">
                    <p className="tl-duration">Sep-2020- April-2024</p>
                    <p>
                      <span className="ui">UI Developer</span>
                      <span>Han river technology</span>
                    </p>
                  </div>

                  {/* <p>
                    I specialize in ReactJS, Vue.js, and UI/UX design, creating dynamic, visually appealing, and user-friendly web applications.
                  </p> */}
                  <p>
                    I have a solid foundation in JavaScript, with experience in functions, DOM manipulation, and ES6
                    features. In React and Vue, I excel in developing intricate designs using props, slots, and components,
                    with a thorough understanding of hooks for effective state management and lifecycle handling.
                    I blend UI design precision with robust frontend , ensuring every project is both visually engaging and highly functional. I focus on crafting intuitive user experiences, implementing modern design principles, and optimizing performance for seamless interactions. With a keen eye for aesthetics and usability, I build responsive, accessible, and scalable web applications that deliver exceptional user experiences across all devices.
                  </p>
                  <br />
                  <ul className="list-work">
                    <h3 className="list-heading">Key Skills & Expertise</h3>
                    <li> UI/UX Design: Proficient in Figma and Adobe Photoshop, with experience collaborating closely with UI designers to translate design concepts into front-end components, ensuring pixel-perfect, responsive, and accessible UI implementations.
                    </li>
                    <li>Advanced Frontend Development: Expertise in React Hooks, Vue Composition API, and state management (Redux, Vuex) for building dynamic, interactive user interfaces.
                    </li>
                    <li>CSS & Styling Mastery: Skilled in CSS Grid, Flexbox, animations, and Tailwind CSS for seamless, interactive designs that enhance user experience.</li>
                    <li>Dynamic & Interactive UI: Developing modals, accordions, carousels, and real-time dashboards with smooth animations.</li>
                    <li> Performance Optimization: Writing clean, maintainable code with a focus on speed, SEO, and cross-browser compatibility.</li>
                  </ul>

                  <ul className="list-work">
                    <h3 className="list-heading">Notable Projects
                    </h3>
                    <li> E-commerce Platform: Led the development of a fully functional e-commerce site using React and Redux, implementing dynamic product displays, an interactive shopping cart, and a smooth checkout process, enhancing user engagement and conversion rates.
                    </li>
                    <li>   Data & Multimedia Platform: Developed a React.js-based platform combining real-time stock market data visualization and multimedia communication features, using Chart.js for market analysis and WebSockets for real-time chat and file sharing.                    </li>
                    <li>Small Projects & Prototypes: Worked on various smaller projects using Bootstrap and Tailwind CSS for responsive and accessible web designs, focusing on clean design and fast deployment.    </li>                <li>Dynamic & Interactive UI: Developing modals, accordions, carousels, and real-time dashboards with smooth animations.</li>
                  </ul>

                </div>
              </div>
            </div>
            <hr />

            <div className="timeLine">
              <div className="timeLine-item">
                <div className="timeLine-icon">
                  <BsBriefcaseFill />
                </div>
                <div className="tl-details">
                  <div className="tl-details-top">
                    <p className="tl-duration">June 2018- Sep 2020</p>
                    <p>
                      {" "} <span className="ui">UI Designner/developer</span>
                      <span>KDK Software</span>
                    </p>
                  </div>
                  <p>
                    UI Design & Frontend Development
                  </p>
                  <ul className="list-work">
                    <li>
                      Actively worked with Figma to design and create UI components like tables and forms.
                    </li>
                    <li>Collaborated closely with senior designers to ensure that the frontend development aligned with UI/UX design standards.</li>
                    <li>Translated Figma designs into responsive and functional frontend components, including the design and implementation of table and form components.</li>
                  </ul>
                  <p></p>
                  <p> I worked on various projects and gained hands-on experience with the following skills, provided and guided by senior designers:</p>
                  <br />
                  <p>
                    <u> HTML5</u> -- Proficient in all essential HTML tags such as table, form, select, article,section , nav, fieldset, and more.
                  </p>
                  <br />
                  <p>
                    <u> CSS3</u> -- Strong knowledge of Grid, Flexbox, positioning, pseudo-classes/elements, transitions/transforms, margin/padding, and font formatting, among others.
                  </p>
                  <br />
                  <p>
                    <u> Figma</u> -- Gained experience in creating responsive designs, interactive prototypes, and design systems. Worked with components, vector editing, and collaborated with teams to ensure smooth project execution.
                  </p>
                  <br />
                  <p>
                    <u>Bootstrap</u> -- Experienced in working with Bootstrap components like tables, cards, accordions, buttons, tabs, form controls, and more.
                  </p>
                  <br />
                  <p>
                    <u>JavaScript</u> -- Adept at handling events, functions, arrays, and statements, with a focus on dynamic behavior.
                  </p>
                </div>
              </div>
              {/* <div className="btn-con">
                <a
                  href="https://drive.google.com/file/d/1HVzz7JMfE49kf8yV3cmIKh8NvE5DLXcM/view?usp=sharing"
                  target="_blank"
                  className="main-btn"
                >
                  <span className="btn-text">Internship-Certificate</span>
                </a>
              </div> */}
            </div>
          </div>
          <hr />
          <div className="about pt-48 about-page">
            <div className="main-title">
              <h2 className="title">
                About <span>me</span>
              </h2>
            </div>
            <div className="about-container pt-48">
              <div className="left-about">
                <h4 className="title">Information About Me</h4>
                <p className="detail-para">
                  I'm Trapti Khandelwal, a passionate UI/UX Designer with a strong foundation in UI development and a creative eye shaped by my background in textile design. After nearly 6 years in the IT industry as a UI developer, I’ve shifted my focus toward user-centered design, combining functionality with aesthetics to craft seamless digital experiences.
                </p>
                <p className="detail-para">
                  My recent journey includes completing the Google UX Design Certificate, followed by a hands-on internship where I worked collaboratively on a platform that helps students access college resources and build resumes. This project allowed me to apply the full Design Thinking process — from empathizing with user needs to defining problems, ideating solutions, prototyping in Figma, and testing for usability.
                </p>
                <p className="detail-para">
                  In addition to the internship, I’ve created detailed UI/UX case studies including:

                  StepVest – An responsive investment learning platform for beginners.

                  MunchOn – A mobile-first snack ordering app for theaters.

                  CollegePur – A responsive platform offering college info, scholarships, and resume tools.I'm proficient in tools like Figma, Photoshop, and comfortable collaborating with developers thanks to my earlier experience with React, Vue.js, and modern HTML/CSS.
                </p>
                <p className="detail-para">
                  Throughout my career, I have completed various certification courses to stay abreast of the latest industry trends and best practices. This ensures that I deliver top-notch solutions for every project I undertake. My experience as a freelance instructor has further solidified my understanding of web development concepts and enhanced my communication and problem-solving skills.I am excited about the endless possibilities in the tech world and am eager to collaborate on innovative projects, leveraging my expertise to create exceptional user experiences."
                </p>
                {/* <div className="btn-con">
                  <a href="https://drive.google.com/file/d/1rldGD7vciszmf_sdyJccDFfYkqsf1T8Z/view?usp=sharing" target="_blank" className="main-btn">
                    <span className="btn-text">Download CV</span>
                    <span className="btn-icon">
                      <AiOutlineDownload />
                    </span>
                  </a>
                </div> */}
              </div>
              <div className="right-about">
                <div className="about-item">
                  <div className="abt-text">
                    <p className="large-text">Learner</p>
                    <p className="small-text">
                      Team-worker
                      <br />
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="abt-text">
                    <p className="large-text">Multi tasker</p>
                    <p className="small-text">
                      Analytical thinking
                      <br />
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="abt-text">
                    <p className="large-text">Innovative Problem Solver</p>
                    <p className="small-text">
                      Effective Communicator
                      <br />
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="abt-text">
                    <p className="large-text">Adaptable</p>
                    <p className="small-text">
                      Detail-Oriented
                      <br />
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="abt-text">
                    <p className="large-text">Creative Thinker</p>
                    <p className="small-text">
                      Deadline-Driven
                      <br />
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="abt-text">
                    <p className="large-text">Collaborative Problem Solver</p>
                    <p className="small-text">
                      Time Management
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="about-stats pt-48">
              <h4 className="stat-title title">My skills</h4>
              <div className="progess-bar-box pt-48">
                <div className="progress-bars">
                  <div className="progress-bar">
                    <p className="prog-title">Figma</p>
                    <div className="progress-con">
                      <p className="prog-text">70%</p>
                      <div className="progress">
                        <span className="figma"></span>
                      </div>
                    </div>
                  </div>
                  <div className="progress-bar">
                    <p className="prog-title">HTML5</p>
                    <div className="progress-con">
                      <p className="prog-text">80%</p>
                      <div className="progress">
                        <span className="html"></span>
                      </div>
                    </div>
                  </div>
                  <div className="progress-bar">
                    <p className="prog-title">CSS3</p>
                    <div className="progress-con">
                      <p className="prog-text">75%</p>
                      <div className="progress">
                        <span className="css"></span>
                      </div>
                    </div>
                  </div>
                  <div className="progress-bar">
                    <p className="prog-title">React</p>
                    <div className="progress-con">
                      <p className="prog-text">50%</p>
                      <div className="progress">
                        <span className="react"></span>
                      </div>
                    </div>
                  </div>
                  <div className="progress-bar">
                    <p className="prog-title">Vue</p>
                    <div className="progress-con">
                      <p className="prog-text">30%</p>
                      <div className="progress">
                        <span className="vue"></span>
                      </div>
                    </div>
                  </div>

                  <div className="progress-bar">
                    <p className="prog-title">Java Script</p>
                    <div className="progress-con">
                      <p className="prog-text">50%</p>
                      <div className="progress">
                        <span className="js"></span>
                      </div>
                    </div>
                  </div>
                  <div className="progress-bar">
                    <p className="prog-title">Bootstrap</p>
                    <div className="progress-con">
                      <p className="prog-text">70%</p>
                      <div className="progress">
                        <span className="bootStrap"></span>
                      </div>
                    </div>
                  </div>

                  <div className="progress-bar">
                    <p className="prog-title">Tailwind</p>
                    <div className="progress-con">
                      <p className="prog-text">70%</p>
                      <div className="progress">
                        <span className="figma"></span>
                      </div>
                    </div>
                  </div>
                </div></div>
            </div></div>
        </section></div>
    </main>
  );
};

export default AboutMe;
